import { DarkMode, LightMode } from "@mui/icons-material";
import { Box, IconButton, useColorScheme } from "@mui/material";

export default function ColorModeIcon() {
  const { mode, systemMode, setMode } = useColorScheme();

  const handleMode = () => {
    if ((systemMode || mode) === "dark") {
      setMode("light");
    } else {
      setMode("dark");
    }
  };

  if (!mode) {
    return (
      <Box
        sx={(theme) => ({
          verticalAlign: "bottom",
          display: "inline-flex",
          width: "2.25rem",
          height: "2.25rem",
          borderRadius: theme.shape.borderRadius,
          border: "1px solid",
          borderColor: theme.palette.divider,
        })}
      />
    );
  }

  const resolvedMode = (systemMode || mode) as "light" | "dark";

  const icon = {
    light: <LightMode />,
    dark: <DarkMode />,
  }[resolvedMode];

  return (
    <IconButton onClick={handleMode} size="small">
      {icon}
    </IconButton>
  );
}
